/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Compare_Event_Groups_Group_Events_LabelInputs */



/**
* | output |
* | --- |
* | "{name} Events" |
*
* @param {Compare_Event_Groups_Group_Events_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_group_events_label = /** @type {((inputs: Compare_Event_Groups_Group_Events_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Group_Events_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événements de ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} Ereignisse`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} Eventi`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`События ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} Eventos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} イベント`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} घटनाएँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eventos ${i?.name}`)
	return /** @type {LocalizedString} */ (`${i?.name} Events`)
});